
  import PopRouteMain from '@/components/util/PopRouteMain'
  import BreadCrumb from '@/components/util/BreadCrumb'
  import SEO from '/mixins/SEO.js';
  import TextualBlockCityB from "../../../../components/util/TextualBlockCityB";
  import FaqCityFromTo from "@/components/util/FaqCityFromTo.vue";
  import MapComponent from "@/components/map/map.vue";
  import ScheduleCityFromTo from "../../../../components/util/ScheduleCityFromTo.vue";
  import ReviewBlock from "@/components/util/ReviewBlock.vue";
  export default {
    name: "CityACityBIndex",
    mixins: [SEO],
    async asyncData({ store, route, $axios }) {

      const info_lading = await $axios.get('/common/get?q=get-lading-page&point_a=' + route.params.city_a + '&point_b=' + route.params.city_b)
      let lowPrice = 20;
      let highPrice = 100;
      let price_object = info_lading.data.price

      if (Object.keys(price_object).length > 0 && price_object.price_max > 0) {
        highPrice = price_object.price_max
        lowPrice = price_object.price_min
      }



      if (lowPrice === highPrice) {
        lowPrice = highPrice / 2
      }

      if (Object.keys(price_object).length > 0 && price_object.price_max < 1) {
        info_lading.data.price.price_max = highPrice
        info_lading.data.price.price_min = lowPrice
        info_lading.data.price.price_avg = (lowPrice + highPrice) / 2
      }

      let title_seo = `Расписание автобусов ${store.getters["util/getUrlForCity"](route.params.city_a)}-${store.getters["util/getUrlForCity"](route.params.city_b)}, купить билет онлайн`
      let description_seo = `‘ОнлайнКасса’ – продажа билетов на автобусы ⭐️ Большой выбор рейсов ${store.getters["util/getUrlForCity"](route.params.city_a)}-${store.getters["util/getUrlForCity"](route.params.city_b)} ⭐️ Привлекательные цены от ${lowPrice} BYN.`

      if (info_lading.data.lading_page.title_meta) title_seo = info_lading.data.lading_page.title_meta
      if (info_lading.data.lading_page.description_meta) description_seo = info_lading.data.lading_page.description_meta

      const list_a = await $axios.get('/common/get?q=get-popular-trip-one&city=' + route.params.city_a)
      const list_b = await $axios.get('/common/get?q=get-popular-trip-one&city=' + route.params.city_b)
      return {
        seo: {
          title: title_seo,
          type: 'website',
          description: description_seo,
          schema:[{
                        type:'application/ld+json',
                        json: [{
                            '@context': 'http://schema.org',
                            '@type': 'Product',
                            'name': `Автобус из ${store.getters["util/getUrlForCity"](route.params.city_a)} в ${store.getters["util/getUrlForCity"](route.params.city_b)}`,
                            'image': 'https://o-kassa.com/img/logo.png',
                            'description': `Автобусные билеты ${ store.getters["util/getUrlForCity"](route.params.city_a)  } ${store.getters["util/getUrlForCity"](route.params.city_b)} на автобусах партнера Онлайн Касса.`,
                            'offers': {
                              "@type": "AggregateOffer",
                              "priceCurrency": "BYN",
                              "offerCount": "1",
                              "lowPrice": lowPrice,
                              "highPrice": highPrice
                            },
                            'aggregateRating' : {
                                  '@type': 'AggregateRating',
                                  'ratingValue': '4,5',
                                  'reviewCount': '265'
                            }
                        },
                          {
                            "@context": "http://schema.org",
                            "@type": "BusTrip",
                            "url": `https://o-kassa.com/${route.path}`,
                            "departureBusStop": {
                              "@type": "BusStop",
                              "name": `${store.getters["util/getUrlForCity"](route.params.city_a) ?? route.params.city_a }`
                            },
                            "arrivalBusStop": {
                              "@type": "BusStop",
                              "name": `${store.getters["util/getUrlForCity"](route.params.city_b ?? route.params.city_a )}`
                            }
                          },
                          {
                            "@context": "http://schema.org/",
                            "@type": "BreadcrumbList",
                            "itemListElement": [
                              {
                                "@type": "ListItem",
                                "position": 1,
                                "item": {
                                  "@id": "https://o-kassa.com/",
                                  "name": `Расписание рейсов по маршруту: ${store.getters["util/getUrlForCity"](route.params.city_a)} в ${store.getters["util/getUrlForCity"](route.params.city_b)} узнать цену, расписание автобусов, купить билет онлайн`,
                                  }
                              },
                              {
                                "@type": "ListItem",
                                "position": 2,
                                "item": {
                                  "@id": `https://o-kassa.com/${route.path}`,
                                  "name": `${store.getters["util/getUrlForCity"](route.params.city_a)} - ${store.getters["util/getUrlForCity"](route.params.city_b)}`
                                }
                              },
                              {
                                "@type": "ListItem",
                                "position": 3,
                                "item": {
                                  "@id": `https://o-kassa.com/${route.path}#`,
                                  "name": "🚌  🚌  🚌"
                                }
                              }
                            ]
                          }
                        ]
          }]
        },
        info_lading: info_lading.data,
        list_a : list_a.data,
        list_b : list_b.data
      };
    },
    components: {
      ReviewBlock,
      ScheduleCityFromTo,
      MapComponent,
      FaqCityFromTo,
      TextualBlockCityB,
      PopRouteMain,
      BreadCrumb
    }
  }
